module.exports = __webpack_public_path__ + "static/toplistphoto-c2ba1894f0556bca80a58067d4c08954.svg";